var _envConfigMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import qs from 'qs';
import guestUser from './guestUser';
var Env;

(function (Env) {
  Env["Dev"] = "dev";
  Env["Stage"] = "stage";
  Env["Prod"] = "prod";
  Env["Fat"] = "fat";
})(Env || (Env = {}));

;
var config = {
  env: Env.Prod,
  sso: false,
  ssoRedirectURI: '',
  clientId: 'gaodingx',
  bizCode: '1',
  // 坐标参数，业务线，1-稿定官方, 2-钉钉公告, 3-FocoVideo, 4-FocoDesign, 5-欢乐逛, 6-天天向商, 7-FocoSlide, 8-商业显示屏
  clientSecret: '7da458070e57b98e11d00d9286f23537'
};
;

function paddingProtocol(url) {
  if (url.startsWith('http')) {
    return url;
  }

  if (typeof location !== 'undefined') {
    return "".concat(location.protocol, "//").concat(url);
  }

  return "https://".concat(url);
}

var envConfigMap = (_envConfigMap = {}, _defineProperty(_envConfigMap, Env.Dev, {
  redirectURI: paddingProtocol('www.dev.gaoding.com/api/ums/redirect'),
  QQRedirectURI: 'http://ums.dev.gaoding.com/sso/qq',
  QiyeWechatRedirectURI: 'https://ums.dev.gaoding.com/sso/qiye-wechat',
  gaodingURL: paddingProtocol('www.dev.gaoding.com'),
  authorizationEndpoint: paddingProtocol('ums.dev.gaoding.com/cgi-bin')
}), _defineProperty(_envConfigMap, Env.Fat, {
  redirectURI: paddingProtocol('fat.gaoding.com/api/ums/redirect'),
  QQRedirectURI: 'https://ums-fat.gaoding.com/sso/qq',
  QiyeWechatRedirectURI: 'https://ums-fat.gaoding.com/sso/qiye-wechat',
  gaodingURL: paddingProtocol('fat.gaoding.com'),
  authorizationEndpoint: paddingProtocol('ums-fat.gaoding.com/cgi-bin')
}), _defineProperty(_envConfigMap, Env.Stage, {
  redirectURI: paddingProtocol('stage.gaoding.com/api/ums/redirect'),
  QQRedirectURI: 'https://stage-ums.gaoding.com/sso/qq',
  QiyeWechatRedirectURI: 'https://ums-stage.gaoding.com/sso/qiye-wechat',
  gaodingURL: paddingProtocol('stage.gaoding.com'),
  authorizationEndpoint: paddingProtocol('ums-stage.gaoding.com/cgi-bin')
}), _defineProperty(_envConfigMap, Env.Prod, {
  redirectURI: paddingProtocol('www.gaoding.com/api/ums/redirect'),
  QQRedirectURI: 'https://ums.gaoding.com/sso/qq',
  QiyeWechatRedirectURI: 'https://ums.gaoding.com/sso/qiye-wechat',
  gaodingURL: paddingProtocol('www.gaoding.com'),
  authorizationEndpoint: paddingProtocol('ums.gaoding.com/cgi-bin')
}), _envConfigMap);
export function getConfig(key) {
  if (['redirectURI', 'QQRedirectURI', 'QiyeWechatRedirectURI', 'gaodingURL', 'authorizationEndpoint'].includes(key)) {
    if (!config[key]) {
      var envConfig = envConfigMap[config.env]; // @ts-ignore

      return envConfig[key];
    }
  }

  return config[key];
} //https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=wx98f312a011a47aab&redirect_uri=http%3A%2F%2Fums.dev.gaoding.com%2Fqiye%2Fsso%2Fthird%2Fqywechat&usertype=member&state=%7B%22device_id%22%3A%2241d36da35f1141be86d9ca06515b13ec%22%2C%22client_id%22%3A%22qiye%22%2C%22suite_id%22%3A%22wx3fd3f5ce8895804c%22%7D  

export function getQywechatAuthUri() {
  return "".concat(getConfig('QiyeWechatRedirectURI'), "?").concat(qs.stringify({
    device_id: guestUser.guestfinger,
    client_id: getConfig('clientId')
  }));
}
;
export default config;